import { render, staticRenderFns } from "./OpenNotifications.vue?vue&type=template&id=c9ce02f8&scoped=true"
import script from "./OpenNotifications.vue?vue&type=script&lang=ts"
export * from "./OpenNotifications.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./OpenNotifications.vue?vue&type=style&index=0&id=c9ce02f8&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c9ce02f8",
  null
  ,true
)

export default component.exports